'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'square-dashed-circle-plus';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e5c2';
var svgPathData = 'M192 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm-40.2-3.5c-2.2-17.5-18.2-30-35.7-27.8-43.5 5.4-77.9 39.8-83.3 83.3-2.2 17.5 10.3 33.5 27.8 35.7S94.1 141.5 96.2 124c1.8-14.4 13.3-25.9 27.7-27.7 17.5-2.2 30-18.2 27.8-35.7zm208.5 0c-2.2 17.5 10.3 33.5 27.8 35.7 10 1.3 18.8 7.2 23.7 15.8 2.7 4.7 4.3 10.1 4.3 16l0 80.7c5.3-.4 10.6-.7 16-.7 16.6 0 32.7 2.1 48 6l0-86c0-17.4-4.7-33.9-12.9-48l0 0c-14.7-25.3-40.6-43.4-71.2-47.2-17.5-2.2-33.5 10.3-35.7 27.8zM128 416c-5.9 0-11.3-1.6-16-4.3-8.5-4.9-14.5-13.6-15.8-23.7-2.2-17.5-18.2-30-35.7-27.8s-30 18.2-27.8 35.7c3.8 30.5 21.9 56.5 47.2 71.2l0 0c14.2 8.2 30.6 12.9 48 12.9l129.4 0c-9.1-19.8-14.9-41.3-16.8-64L128 416zM64 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-160l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSquareDashedCirclePlus = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;